import { render } from "./AlienPlayerScoutReportForm.vue?vue&type=template&id=856aabc0"
import script from "./AlienPlayerScoutReportForm.vue?vue&type=script&lang=js"
export * from "./AlienPlayerScoutReportForm.vue?vue&type=script&lang=js"

import "./AlienPlayerScoutReportForm.vue?vue&type=style&index=0&id=856aabc0&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__